module.exports = __webpack_public_path__ + "static/media/main_navbar_logo.c0870fa5.png";